
// Event types 
export enum AnalyticsEventType {
    PAGE_VIEW = 'page_view',
    INTERACTION_SIDEBAR = 'mega_menu',
    INTERACTION_MASMENU = 'interaction_masmenu',
    VIEW_MODAL = 'view_modal',
    INTERACTION_MODAL = 'interaction_modal',
    INTERACTION_NAVBAR = 'interaction_navbar',
    INTERACTION_ABOUT_GEPP = 'interaction_about_gepp',
    INTERACTION_HEADER = 'interaction_header',
    SELECT_NOTIFICATION = 'select_notification',
    INTERACTION_ARTICLE = 'interaction_article',
    // Recompepsi
    LOYALITY_PROGRAM_INTERACTION = 'loyalty_program_interaction',
    MOVEMENT_DATE_SELECTION = 'movement_date_selection',
    AVANCE_FAVORITOS = 'avance_favoritos',
    FINALIZADO_FAVORITOS = 'finalizado_favoritos'
}

export enum EAnalyticsEcommerce {
    begin_checkout = 'begin_checkout',
    ecommerce_purchase = 'ecommerce_purchase',
    add_to_cart = 'add_to_cart',
    remove_from_cart = 'remove_from_cart'
}

export enum EListType {
    order_suggested = 'pedido_sugerido',
    recommender_customers = 'recomendador_clientes',
    recommender_user = 'recomendador_usuario',
    catalogue = 'catalogo',
    search_result = 'resultados_busqueda',
    cart_products = 'productos_carrito',
    store_list_products = 'tienda_lista_productos'
}

export enum EBannerEvents {
    banner_order_suggested = 'select_promotion',
    view_banner_order_suggested = 'view_promotion'
}

export enum EProductEventType {
    add = 'mas_producto',
    remove = 'menos_producto'
}

export enum EModuleName {
    suggested_order = 'Pedido sugerido',
    most_selled = 'Lo más vendido cerca de ti',
}

export enum EProductsListTypes {
    suggested_order = 'pedido_sugerido',
    most_selled = 'lo_mas_vendido_cerca_de_ti',
    all_products = 'todos_los_productos',
    busqueda = 'busqueda',
    categorias = 'categorias',
}

export enum EMenuHamburguerEvents {
    Juegos = 'gamesMenuHamburguerEvent',
    'Autoevaluacion' = 'executionPhotoMenuHamburguerEvent',
    'Centro-Asistencia' = 'assistanceCenterMenuHamburguerEvent',
    'Impulsa-GEPP' = 'boostGeppMenuHamburguerEvent',

}

export enum EMenuMoreEvents {
    Juegos = 'gamesMenuMoreEvent',
    'Autoevaluacion' = 'executionPhotoMenuMoreEvent',
    'Centro-Asistencia' = 'assistanceCenterPhotoMenuMoreEvent',
    'Impulsa-GEPP' = 'boostGeppMenuMoreEvent',
}

export enum EAnalyticsHeaderLabels {
    FAVORITOS = 'favoritos',
    PROMOCIONES = 'promociones',
    TENDENCIAS = 'tendencias',
    CATEGORIAS = 'categorias',
    BUSCADOR = 'buscador',
    MENU = 'menu',
    VER_ACTIVIDAD = 'ver_actividad',
    ATRAS = 'atras',
    NOTIFICACIONES = 'notificaciones',
    AYUDA = 'ayuda',
    JUEGOS = 'juegos',
    IMPULSA_GEPP = 'impulsa_gepp',
    MECANICA = 'mecanica',
    HISTORICO = 'historico'
}

export enum ESectionProperty {
    plp = 'PLP',
    pdp = 'PDP',
    cart = 'cart',
    checkout = 'checkout',
    confirmation = 'confirmation',
    promociones = 'Promociones',
    plp_search = "PLP search",
    tienda = 'Tienda',
}

export const EAnalyticsEvents: { [key: string]: any } = {
    loginEvent: {
        event: 'login',
        method: 'Telefono',
        flow: 'vendedor'
    },
    searchProductEvent: {
        event: 'search',
        flow: 'vendedor'
    },
    flowSelectorEvent: {
        event: 'flow_selector'
    },
    interactionAboutEvent: {
        event: 'interaction_about_gepp',
        flow: "consumidor",
    },
    viewItemListEvent: {
        event: "view_item_list",
    },
    viewPromotion: {
        event: "view_promotion"
    },
    selectPromotion: {
        event: "select_promotion"
    },
    addToCart: {
        event: "add_to_cart"
    },
    removeFromCart: {
        event: 'remove_from_cart'
    },
    beginCheckout: {
        event: 'begin_checkout'
    },
    purchase: {
        event: 'purchase'
    },
    refund: {
        event: 'refund'
    },
    viewLimit: {
        event: 'view_limit',
        element: '500',
        flow: 'vendedor',
        section: 'checkout'
    },
    transactionLimit: {
        event: 'transaction_limit',
        element: '500',
        flow: 'vendedor',
        section: 'checkout',
        id_transaction: ''
    },
    environment: {
        event: 'environment',
    },
    megaMenuEvent: {
        event: 'mega_menu',
        section: '',
        element: '',
        url: ''
    }
}

export const EAnalyticsPageViews = {
    moreAboutGeppView: { // 2.2
        page_title: 'mas_sobre_gepp',
        flow: "consumidor",
    },
    userNotFoundView: { // 3.2
        page_title: 'error_login_usuario_no_encontrado',
        flow: "vendedor",

    },
    recoveryPasswordPhoneView: { // 4.1
        page_title: 'recuperar_contrasena_telefono',
        flow: "vendedor",
    },
    recoveryPasswordSMSView: { // 4.2
        page_title: 'recuperar_contrasena_sms',
        flow: "vendedor",
    },
    registerEditSMSView: { // 7.1
        page_title: 'registro_editar_num_sms',
        flow: "vendedor",
    },
    registerSMSValidationView: { // 6.2
        page_title: 'registro_validacion_sms',
        flow: "vendedor",
    },
    registerInitialDataView: { // 6.1
        page_title: 'registro_datos_iniciales',
        flow: "vendedor",
    },
    recoveryPassNewView: { // 5.1
        page_title: 'recuperar_contrasena_ingresa_nueva',
        flow: "vendedor",
    },
    registerProfileView: { // 7.2
        page_title: 'registro_perfil',
        flow: "vendedor",
    },
    registerUserNotFoundView: { // 8.2
        page_title: 'error_registro_usuario_no_encontrado',
        flow: "vendedor",
    },
    errorRegisterExceededView: { // 9.1
        page_title: 'error_registro_intentos_excedidos',
        flow: "vendedor",
    },
    errorRegisterUserExistingView: { // 9.2
        page_title: 'error_registro_usuario_existente',
        flow: "vendedor",
    },
    loyaltyProgramView: { // 10.1, 10.2, 11.1, 11.2
        page_title: 'programa',
        flow: "vendedor",
    },
    dynamicProgramView: { // 12.1
        page_title: 'programa_dinamica',
        flow: "vendedor",
    },
    dynamicProgramZoomView: { // 12.2
        page_title: 'programa_detalle_mecanica_zoom',
        flow: "vendedor",
    },
    programClosedView: { // 13.1
        page_title: 'programa_cierre',
        flow: "vendedor",
    },
    programAchievementsView: { // 14.1
        page_title: 'programa_mis_logros',
        flow: "vendedor",
    },
    storeSummaryTicketView: {
        flow: "vendedor",
        page_title: 'tienda_resumen_ticket',
    },
    shoppingHistoryView: { // 22.1, 22.2
        page_title: 'historial_compras',
        flow: "vendedor",
    },
    eTicketPresaleView: { // 23.1
        page_title: 'eticket_preventa',
        flow: "vendedor",
    },
    eTicketDeliveryView: { // 23.2
        page_title: 'eticket_entrega',
        flow: "vendedor",
    },
    portfolioView: { // 24.1
        page_title: 'portafolio',
        flow: "vendedor",
    },
    portfolioCompletedView: { // 24.2
        page_title: 'portafolio_cumplido',
        flow: "vendedor",
    },
    feedAllView: { // 25.1
        page_title: 'feed_todo',
        flow: "vendedor",
    },
    feedNewsView: { // 25.1
        page_title: 'feed_noticias',
        flow: "vendedor",
    },
    feedPromoView: { // 25.1
        page_title: 'feed_promos',
        flow: "vendedor",
    },
    newsDetailView: { // 25.2
        page_title: 'feed_noticias_detalle',
        flow: "vendedor",
    },
    promoDetailView: { // 26.1
        page_title: 'feed_promos_detalle',
        flow: "vendedor",
    },
    editProfileView: { // 26.2
        page_title: 'perfil_edicion',
        flow: "vendedor",
    },
    profileEditPasswordView: { // 27.1
        page_title: 'perfil_edicion_contrasena',
        flow: "vendedor",
    },
    profileEditPhoneView: { // 27.2
        page_title: 'perfil_edicion_telefono',
        flow: "vendedor",
    },
    successEditProfileView: { // 28.1
        page_title: 'perfil_edicion_exitoso',
        flow: "vendedor",
    },
    editProfileNoChangesView: { // 28.2
        page_title: 'perfil_edicion_sin_cambio',
        flow: "vendedor",
    },
    profilePreEditPasswordView: { // 29.1
        page_title: 'perfil_pre_edicion_contrasena',
        flow: "vendedor",
    },
    profilePreEditPhoneView: { // 29.2
        page_title: 'perfil_pre_edicion_telefono',
        flow: "vendedor",
    },
    profileEditSMSView: { // 30.1
        page_title: 'perfil_edicion_sms',
        flow: "vendedor",
    },
    rateUsView: { // 30.2
        page_title: 'calificanos',
        flow: "vendedor",
    },
    rateUsThanksView: { // 31.1
        page_title: 'calificanos_gracias',
        flow: "vendedor",
    },
    contactLineView: { // 31.2
        page_title: 'linea_contacto',
        flow: "vendedor",
    },
    noticeOfPrivacyView: { // 32.1
        page_title: 'aviso_privacidad',
        flow: "vendedor",
    },
    termsAndConditionsView: {
        page_title: 'terminos_condiciones',
        flow: "vendedor",
    },
    notificationsView: { // 32.2
        page_title: 'notificaciones',
        flow: "vendedor",
    },
    emptyNotificationsView: { // 33.1
        page_title: 'notificaciones_vacia',
        flow: "vendedor",
    },
    assistanceCenterView: { // 35.2
        page_title: 'centro_asistencia',
        flow: "vendedor",
    },
    assistanceCenterThankyouView: { // 43.1
        page_title: 'asistencia_contacto_gracias',
        flow: "vendedor",
    },
    menuMoreView: { // 48.1
        page_title: 'menu_mas',
        flow: "vendedor",
    },
    executionNotifView: { // 48.2
        page_title: 'ejecucion_notificacion_tomarfoto',
        flow: "vendedor",
    },
    executionMenuView: { // 49.2
        page_title: 'ejecucion_menu',
        flow: "vendedor",
    },
    executionZoomView: { // 50.1
        page_title: 'ejecucion_zoom_imagen',
        flow: "vendedor",
    },
    executionCompletedView: { // 51.1
        page_title: 'ejecucion_menu_completo',
        flow: "vendedor",
    },
    executionResultsView: { // 51.2
        page_title: 'ejecucion_foto_resultados',
        flow: "vendedor",
    },
    executionPhotoTypeView: { // 52.1
        page_title: 'ejecucion_foto',
        flow: "vendedor",
    },
    legalsUpdatedView: { // 55.2
        page_title: 'aviso_actualizacion_terminos',
        flow: "vendedor",
    },
    userUnregisterView: { // 56.1
        page_title: 'registra_cuenta_como_nueva',
        flow: "vendedor",
    },
    userDisabledView: { // 57.1
        page_title: 'cuenta_inhabilitada',
        flow: "vendedor",
    },
    promotionsEcommerceView: {
        flow: "vendedor",
        page_title: 'tienda_listado_promociones',
    },
    promoDynamicView: {
        page_title: '/tienda_promocion_dinamica',
        flow: "vendedor",
    },
    promoStairView: {
        page_title: '/tienda_promocion_escalera',
        flow: "vendedor",
    },
    promoBonificacionView: {
        page_title: '/tienda_promocion_bonificacion',
        flow: "vendedor",
    },
    businessGrowsView: { // Por Definir
        page_title: 'crece_negocio',
        flow: "vendedor",
    },
    suggestedOrderView: { // 64.1
        flow: "vendedor",
        page_title: 'pedido_sugerido',
    },
    especialsOrderView: { // 64.1
        flow: "vendedor",
        page_title: 'especiales_del_mes',
    },
    mostSelledCloseView: { // 64.1
        flow: "vendedor",
        page_title: 'lo_mas_vendido_cerca_de_ti',
    },
    orderCompletedView: {
        flow: "vendedor",
        page_title: 'tienda_confirmacion_compra',
    },
    interestProductsView: { // 65.1
        page_title: 'te_puede_interesar',
        flow: 'vendedor'
    },
    newSectionGamesView: { // Gamification 3.2
        page_title: 'juegos_bienvenida',
        flow: 'vendedor'
    },
    dashboardGamesView: { // Gamification 4.1
        page_title: 'juegos_inicio',
        flow: 'vendedor'
    },
    leaderbordGamesView: { // Gamification 4.2
        page_title: 'ranking_juegos',
        flow: 'vendedor'
    },
    dailyLifesGamesView: { // Gamification 6.1
        page_title: 'recompensa_diaria',
        flow: 'vendedor'
    },
    firstLifesGamesView: { // Gamification 6.2
        page_title: 'obsequio_vidas',
        flow: 'vendedor'
    },
    zeroLifesGamesView: { // Gamification 7.1
        page_title: 'sin_vidas',
        flow: 'vendedor'
    },
    boostGeppView: { // Impulsa Gepp 1
        page_title: 'impulsa_gepp',
        flow: "vendedor",
    },
    errorConnectionGamesView: { // Gamification 5.2
        page_title: 'error_conexion_juegos',
        flow: 'vendedor'
    },
    errorListGamesView: { // Gamification 5.1
        page_title: 'error_actualizacion_juegos',
        flow: 'vendedor'
    },
    cancelAccount: {
        page_title: 'cancelar_cuenta',
        flow: 'vendedor'
    },
    errorWithoutInternetView: { // 33.2
        page_title: 'error_sin_internet',
    },
    errorNoDataView: { // 34.1
        page_title: 'error_sin_datos',
    },
    errorWeHaveDifficultiesView: { // 34.2
        page_title: 'error_dificultades',
    },
    coolersView: {
        page_title: 'enfriadores',
    },
    //v2
    gamesView: {
        page_title: 'juegos_view',
        flow: 'vendedor'
    },
    promo_dinamica_modal: {
        page_title: 'promo_dinamica_modal',
        flow: 'vendedor'
    },
    promo_escalera_modal: {
        page_title: 'promo_escalera_modal',
        flow: 'vendedor'
    },
    tienda_tab_favoritos: {
        page_title: 'tienda_tab_favoritos',
        flow: 'vendedor'
    },
    tienda_tab_promociones: {
        page_title: 'tienda_tab_promociones',
        flow: 'vendedor'
    },
    tienda_tab_tendencias: {
        page_title: 'tienda_tab_tendencias',
        flow: 'vendedor'
    },
    tienda_tab_categorias: {
        page_title: 'tienda_tab_categorias',
        flow: 'vendedor'
    },
    marketChangeView: {
        page_title: 'cambios_de_producto',
    },
    welcomeView: {
        page_title: 'welcome_view'
    },
    loginView: {
        page_title: 'login_view',
        flow: "vendedor",
    },
    cartView: {
        page_title: 'carrito_view',
        flow: "vendedor",
    },
    resumenPedidoView: {
        page_title: 'resumen_pedido_view',
        flow: "vendedor",
    },
    confirmacionPedidoView: {
        page_title: 'confirmacion_view',
    },
    perfilView: {
        page_title: 'perfil_view',
        flow: "vendedor",
    },
    juegosView: {
        page_title: 'juegos_view',
    },
    misPedidosView: {
        page_title: 'mis_pedidos_view',
    },
    recompepsiView: {
        page_title: 'programa_recompepsi',
    }
}

export const EAnalyticsModals = {
    promotionModalRegistro: {
        event: 'view_modal',
        flow: 'vendedor',
        trigger: "auto",
        is_dismissible: false,
        step: '-',
    },
    promotionModalRegistroInteraction: {
        event: 'interaction_modal',
        interaction_type: 'click',
        flow: 'vendedor',
    }
}

// Common
// Navbar / Menu
export const AppAnalyticsEvents: { [key: string]: any } = {
    sidebarInteraction: {
        event: AnalyticsEventType.INTERACTION_SIDEBAR
    },
    masmenuInteraction: {
        event: AnalyticsEventType.INTERACTION_MASMENU
    },
    navbarInteraction: {
        event: AnalyticsEventType.INTERACTION_NAVBAR
    }
}


// Market change events 

// Modals
export const MCAnalyticsModals = {
    help: {
        event: AnalyticsEventType.VIEW_MODAL,
        modal_id: 'cambios_de_producto',
        modal_title: 'Cambios de producto',
        modal_type: 'help',
        trigger: 'user',
        is_dismissible: true,
    },
    exit: {
        event: AnalyticsEventType.VIEW_MODAL,
        modal_id: 'exit_intent',
        modal_title: 'Aún no has enviado esta solicitud ¿Seguro deseas salir?',
        modal_type: 'confirm',
        trigger: 'exit_intent',
        is_dismissible: true,
    },
    problemSend: {
        event: AnalyticsEventType.VIEW_MODAL,
        modal_id: 'error_api',
        modal_title: 'Estamos teniendo problemas para enviar tu solicitud. Por favor inténtalo más tarde',
        modal_type: 'error',
        trigger: 'error_api',
        is_dismissible: true,
    },
    productDelete: {
        event: AnalyticsEventType.VIEW_MODAL,
        modal_id: 'eliminar_producto',
        modal_title: '¿Seguro deseas eliminar el producto de tu solicitud?',
        modal_type: 'confirm',
        trigger: 'user',
        is_dismissible: true,
    },
    deleteSend: {
        event: AnalyticsEventType.VIEW_MODAL,
        modal_id: 'eliminar_solicitud_activa',
        modal_title: '¿Seguro deseas eliminar esta solicitud?',
        modal_type: 'confirm',
        trigger: 'user',
        is_dismissible: true,
    }
}

// Events
export const MCAnalyticsEvents = {
    exitModalConfirm: {
        event: AnalyticsEventType.INTERACTION_MODAL,
        interaction_type: 'confirm',
        modal_id: MCAnalyticsModals.exit.modal_id,
        modal_title: MCAnalyticsModals.exit.modal_title
    },
    exitModalCancel: {
        event: AnalyticsEventType.INTERACTION_MODAL,
        interaction_type: 'cancel',
        modal_id: MCAnalyticsModals.exit.modal_id,
        modal_title: MCAnalyticsModals.exit.modal_title
    },
    helpModal: {
        event: AnalyticsEventType.INTERACTION_MODAL,
        interaction_type: 'close',
        modal_id: MCAnalyticsModals.help.modal_id,
        modal_title: MCAnalyticsModals.help.modal_title,
    },
    problemSendModalExit: {
        event: AnalyticsEventType.INTERACTION_MODAL,
        interaction_type: 'close',
        modal_id: MCAnalyticsModals.problemSend.modal_id,
        modal_title: MCAnalyticsModals.problemSend.modal_title,
    },
    productDeleteModalConfirm: {
        event: AnalyticsEventType.INTERACTION_MODAL,
        interaction_type: 'confirm',
        modal_id: MCAnalyticsModals.productDelete.modal_id,
        modal_title: MCAnalyticsModals.productDelete.modal_title,
    },
    productDeleteModalCancel: {
        event: AnalyticsEventType.INTERACTION_MODAL,
        interaction_type: 'cancel',
        modal_id: MCAnalyticsModals.productDelete.modal_id,
        modal_title: MCAnalyticsModals.productDelete.modal_title,
    },
    deleteSendModalConfirm: {
        event: AnalyticsEventType.INTERACTION_MODAL,
        interaction_type: 'confirm',
        modal_id: MCAnalyticsModals.deleteSend.modal_id,
        modal_title: MCAnalyticsModals.deleteSend.modal_title,
    },
    deleteSendModalCancel: {
        event: AnalyticsEventType.INTERACTION_MODAL,
        interaction_type: 'cancel',
        modal_id: MCAnalyticsModals.deleteSend.modal_id,
        modal_title: MCAnalyticsModals.deleteSend.modal_title,
    },
    productChangeEvent: {
        event: 'product_change',
        timestamp: new Date().toISOString(),
    },
    modificationProductChangeEvent: {
        event: 'modification_product_change',
        timestamp: new Date().toISOString(),
    },
    deleteProductChangeEvent: {
        event: 'delete_product_change',
        timestamp: new Date().toISOString(),
    },
    addToWhislistEvent: {
        event: 'add_to_wishlist',
        timestamp: new Date().toISOString(),
    }
}

// Programa recompepsi events


// Modals
export const RecompepsiAnalyticsModals = {
    recompepsi: {
        event: AnalyticsEventType.VIEW_MODAL,
        modal_id: 'recompepsi',
        modal_title: 'recompepsi',
        modal_type: 'help',
        trigger: 'user',
        is_dismissible: true,
    },
    comprasDelMes: {
        event: AnalyticsEventType.VIEW_MODAL,
        modal_id: 'compras_del_mes',
        modal_title: 'Pts. por compra',
        modal_type: 'help',
        trigger: 'user',
        is_dismissible: true,
    },
    cuotaMensual: {
        event: AnalyticsEventType.VIEW_MODAL,
        modal_id: 'cuota_mensual',
        modal_title: 'cuota mensual',
        modal_type: 'help',
        trigger: 'user',
        is_dismissible: true,
    },
    autoevaluacion: {
        event: AnalyticsEventType.VIEW_MODAL,
        modal_id: 'autoevaluacion',
        modal_title: 'autoevaluacion',
        modal_type: 'help',
        trigger: 'user',
        is_dismissible: true,
    },
    cajasGanadas: {
        event: AnalyticsEventType.VIEW_MODAL,
        modal_id: 'cajas_ganadas',
        modal_title: 'cajas ganadas',
        modal_type: 'help',
        trigger: 'user',
        is_dismissible: true,
    },
    legales: {
        event: AnalyticsEventType.VIEW_MODAL,
        modal_type: 'legales',
        trigger: 'auto',
        is_dismissible: false,
    }
}

// Events
export const RecompepsiAnalyticsEvents = {
    sectionTab: {
        event: AnalyticsEventType.LOYALITY_PROGRAM_INTERACTION,
        label: 'tab'
    },
    recompepsiCardTooltip: {
        event: AnalyticsEventType.LOYALITY_PROGRAM_INTERACTION,
        label: 'tooltip recompepsi'
    },
    recompepsiModalClose: {
        event: AnalyticsEventType.INTERACTION_MODAL,
        interaction_type: 'close',
        modal_id: RecompepsiAnalyticsModals.recompepsi.modal_id,
        modal_title: RecompepsiAnalyticsModals.recompepsi.modal_title,
    },
    comprasDelMesCardTooltip: {
        event: AnalyticsEventType.LOYALITY_PROGRAM_INTERACTION,
        label: 'tooltip pts. por compra'
    },
    comprasDelMesModalClose: {
        event: AnalyticsEventType.INTERACTION_MODAL,
        interaction_type: 'close',
        modal_id: RecompepsiAnalyticsModals.comprasDelMes.modal_id,
        modal_title: RecompepsiAnalyticsModals.comprasDelMes.modal_title,
    },
    cuotaMensualTooltip: {
        event: AnalyticsEventType.LOYALITY_PROGRAM_INTERACTION,
        label: 'tooltip cuota mensual'
    },
    cuotaMensualClose: {
        event: AnalyticsEventType.INTERACTION_MODAL,
        interaction_type: 'close',
        modal_id: RecompepsiAnalyticsModals.cuotaMensual.modal_id,
        modal_title: RecompepsiAnalyticsModals.cuotaMensual.modal_title,
    },
    autoevaluacionCardTooltip: {
        event: AnalyticsEventType.LOYALITY_PROGRAM_INTERACTION,
        label: 'tooltip autoevaluacion'
    },
    autoevaluacionModalClose: {
        event: AnalyticsEventType.INTERACTION_MODAL,
        interaction_type: 'close',
        modal_id: RecompepsiAnalyticsModals.autoevaluacion.modal_id,
        modal_title: RecompepsiAnalyticsModals.autoevaluacion.modal_title,
    },
    autoevaluacionCardBtnEmpezar: {
        event: AnalyticsEventType.LOYALITY_PROGRAM_INTERACTION,
        label: 'boton autoevaluacion empezar'
    },
    autoevaluacionCardBtnResultados: {
        event: AnalyticsEventType.LOYALITY_PROGRAM_INTERACTION,
        label: 'boton autoevaluacion ir a resultados'
    },
    acumulaPuntosBtnIrALaTienda: {
        event: AnalyticsEventType.LOYALITY_PROGRAM_INTERACTION,
        label: 'boton acumula puntos ir a la tienda'
    },
    cajasGanadasCardTooltip: {
        event: AnalyticsEventType.LOYALITY_PROGRAM_INTERACTION,
        label: 'tooltip cajas ganadas'
    },
    cajasGanadasModalClose: {
        event: AnalyticsEventType.INTERACTION_MODAL,
        interaction_type: 'close',
        modal_id: RecompepsiAnalyticsModals.cajasGanadas.modal_id,
        modal_title: RecompepsiAnalyticsModals.cajasGanadas.modal_title,
    },
    movimientosPeriodo: {
        event: AnalyticsEventType.MOVEMENT_DATE_SELECTION
    },
    legalsCheckbox: {
        event: AnalyticsEventType.INTERACTION_MODAL,
        label: 'checkbox acepto terminos y condiciones',
    },
    legalsBtnContinuar: {
        event: AnalyticsEventType.INTERACTION_MODAL
    }
}